<template>
    <svg
        id="Clock"
        xmlns="http://www.w3.org/2000/svg"
        width="22.5"
        height="22.5"
        viewBox="0 0 22.5 22.5"
    >
        <path
            id="Pfad_308"
            data-name="Pfad 308"
            d="M233.607,124.727"
            transform="translate(-229.235 -119.008)"
            :class="fillClass + ' transition-fill'"
        />
        <g id="Check" transform="translate(-229.235 -119.008)">
            <path
                id="Pfad_309"
                data-name="Pfad 309"
                d="M240.485,141.508a11.25,11.25,0,1,1,11.25-11.25A11.262,11.262,0,0,1,240.485,141.508Zm0-21a9.75,9.75,0,1,0,9.75,9.75A9.761,9.761,0,0,0,240.485,120.508Z"
                :class="fillClass + ' transition-fill'"
            />
            <path
                id="Pfad_310"
                data-name="Pfad 310"
                d="M244.327,135.879a.744.744,0,0,1-.347-.085l-5.039-2.628a1.281,1.281,0,0,1-.691-1.14V126a.75.75,0,0,1,1.5,0v5.9l4.924,2.568a.75.75,0,0,1-.347,1.415Z"
                transform="translate(0 -0.242)"
                :class="fillClass + ' transition-fill'"
            />
        </g>
    </svg>
</template>
<script>
import { defineComponent } from "vue";

export default defineComponent({
    name: "ClockIcon",
    props: {
        fillClass: {
            type: String,
            required: true,
            default: "fill-white",
        },
    },
});
</script>
